(() => {
  if (window.__pvInit) return;
  window.__pvInit = true;

  const root = document.getElementById('pv-popup');
  if (!root) return;

  const sheet = root.querySelector('.pv__sheet');
  const track = root.querySelector('[data-pv-track]');
  const titleEl = root.querySelector('#pv-title');
  const errEl = root.querySelector('[data-pv-error]');
  const html = document.documentElement;
  const cache = new Map(); // raw data string -> rendered HTML (parse/render once per product)
  let lastFocus = null;
  let closeTimer = null;
  let busy = false;

  const esc = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const jar = (g) => {
    if (!g) return '';
    g = String(g).trim();
    return /^[\d.,]+$/.test(g) ? `₹${esc(g)}/Jar` : esc(g);
  };

  const card = (v) => `
    <div class="pv-card">
      <div class="pv-card__box">
        ${v.off > 0 ? `<span class="pv-card__save">Save ${v.off}%</span>` : ''}
        ${v.img ? `<img class="pv-card__img" src="${esc(v.img)}" alt="${esc(v.t)}" loading="lazy" decoding="async">` : '<div class="pv-card__img"></div>'}
        <button type="button" class="pv-card__btn" data-pv-add="${v.id}" ${v.a ? '' : 'disabled'}>
          ${v.a ? 'ADD TO CART' : 'SOLD OUT'}
        </button>
      </div>
      <p class="pv-card__name">${esc(v.t)}</p>
      <div class="pv-card__price"><span>₹${esc(v.p)}</span>${v.c ? `<s>₹${esc(v.c)}</s>` : ''}</div>
      ${v.gm ? `<p class="pv-card__jar">${jar(v.gm)}</p>` : ''}
      <p class="pv-card__stock ${v.a ? '' : 'is-out'}">${v.a ? 'In stock' : 'Out of stock'}</p>
    </div>`;

  const showError = (msg) => {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  };

  const open = (btn) => {
    const raw = btn.dataset.pv;
    if (!raw) return;
    let markup = cache.get(raw);
    if (!markup) {
      try {
        markup = JSON.parse(raw).map(card).join('');
      } catch (e) {
        console.error('[variant-popup] bad data', e);
        return;
      }
      cache.set(raw, markup);
    }
    clearTimeout(closeTimer);
    lastFocus = btn;
    titleEl.textContent = btn.dataset.pvTitle || '';
    track.innerHTML = markup;
    track.scrollLeft = 0;
    showError('');
    root.hidden = false;
    html.classList.add('pv-lock');
    void root.offsetWidth; // reflow so the slide-up transition runs
    root.classList.add('is-open');
    root.querySelector('.pv__close').focus({ preventScroll: true });
  };

  const close = () => {
    if (root.hidden) return;
    root.classList.remove('is-open');
    html.classList.remove('pv-lock');
    closeTimer = setTimeout(() => {
      root.hidden = true;
      track.innerHTML = '';
      lastFocus && lastFocus.focus({ preventScroll: true });
    }, 380);
  };

  const refreshCart = async (resp) => {
    // Dawn-style cart drawer / notification support, falls back to a generic event.
    try {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && resp.sections && typeof cart.renderContents === 'function') {
        cart.renderContents(resp);
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-popup', productVariantId: resp.id, cartData: resp });
      }
    } catch (e) {
      console.warn('[variant-popup] cart refresh fallback', e);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: resp }));
  };

  const add = async (btn) => {
    if (busy) return;
    busy = true;
    showError('');
    const label = btn.textContent.trim();
    btn.classList.add('is-loading');
    btn.textContent = 'ADDING...';

    try {
      const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { id: Number(btn.dataset.pvAdd), quantity: 1 };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        body.sections = cartEl.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');

      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      btn.textContent = 'ADDED';
      await refreshCart(data);
      setTimeout(close, 450);
    } catch (e) {
      showError(e.message);
      btn.textContent = label;
      btn.classList.remove('is-loading');
    } finally {
      busy = false;
    }
  };

  // One delegated listener for the whole page (works for cards injected later via infinite scroll/filters)
  document.addEventListener('click', (e) => {
    const t = e.target;
    const openBtn = t.closest('[data-pv-open]');
    if (openBtn) {
      e.preventDefault();
      return open(openBtn);
    }
    if (root.hidden) return;
    const addBtn = t.closest('[data-pv-add]');
    if (addBtn && !addBtn.disabled) return add(addBtn);
    if (t.closest('[data-pv-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (root.hidden) return;
    if (e.key === 'Escape') return close();
    if (e.key === 'Tab') {
      // basic focus trap
      const f = sheet.querySelectorAll('button:not([disabled])');
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
